import { render, staticRenderFns } from "./CardItem.vue?vue&type=template&id=ccab92a2&scoped=true"
import script from "./CardItem.vue?vue&type=script&lang=js"
export * from "./CardItem.vue?vue&type=script&lang=js"
import style0 from "./CardItem.vue?vue&type=style&index=0&id=ccab92a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccab92a2",
  null
  
)

export default component.exports